(() => {
  const clamp = (value) => Math.min(1, Math.max(0, value));
  const lerp = (start, end, progress) =>
    start + (end - start) * progress;
  const smoothstep = (progress) =>
    progress * progress * (3 - 2 * progress);
  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  const updateVariantExperience = (root, input, animate = false) => {
    if (!input) return;

    const title = input.dataset.title || "";
    const price = input.dataset.price || "";
    const centimetres = input.dataset.centimetres || "";
    const fit = input.dataset.fit || "";
    const available = input.dataset.available === "true";
    const isLong = title.includes("72");

    root.querySelectorAll("[data-cf-sc-price]").forEach((element) => {
      element.textContent = price;
    });

    document.querySelectorAll("[data-cf-sc-editorial-price]").forEach((element) => {
      element.textContent = price;
    });

    root.querySelectorAll("[data-cf-sc-float-variant]").forEach((element) => {
      element.textContent = `${title} · ${price}`;
    });

    root.querySelectorAll("[data-cf-sc-add]").forEach((button) => {
      button.disabled = !available;
      button.textContent = available ? `Add ${title} to bag` : "Sold out";
    });

    document.querySelectorAll("[data-cf-sc-size-option]").forEach((button) => {
      button.setAttribute(
        "aria-pressed",
        button.dataset.variantId === input.value ? "true" : "false",
      );
    });

    document.querySelectorAll("[data-cf-sc-fit-title]").forEach((element) => {
      element.textContent = title;
    });

    document
      .querySelectorAll("[data-cf-sc-fit-centimetres]")
      .forEach((element) => {
        element.textContent = centimetres;
      });

    document
      .querySelectorAll("[data-cf-sc-fit-description]")
      .forEach((element) => {
        element.textContent = fit;
      });

    document.querySelectorAll("[data-cf-sc-fit-cord]").forEach((element) => {
      element.style.setProperty("--cf-sc-fit-width", isLong ? "82%" : "68%");
    });

    if (animate && !reducedMotion) {
      window.clearTimeout(root.cfScVariantTimer);
      root.classList.remove("is-variant-locking");
      void root.offsetWidth;
      root.classList.add("is-variant-locking");
      root.cfScVariantTimer = window.setTimeout(() => {
        root.classList.remove("is-variant-locking");
      }, 620);
    }
  };

  const initRoot = (root) => {
    if (root.dataset.cfScReady === "true") return;
    root.dataset.cfScReady = "true";
    document.documentElement.classList.add("cf-sc-page");
    document.body?.classList.add("cf-sc-page");

    const form = root.querySelector("[data-cf-sc-form]");
    const hero = root.querySelector("[data-cf-sc-hero]");
    const floatBuy = root.querySelector("[data-cf-sc-float-buy]");
    const localNav = root.querySelector("[data-cf-sc-local-nav]");
    const variantInputs = Array.from(
      root.querySelectorAll("[data-cf-sc-variant]"),
    );

    localNav?.querySelectorAll('a[href^="#"]').forEach((link) => {
      link.addEventListener("click", (event) => {
        const target = document.querySelector(link.getAttribute("href"));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({
          behavior: reducedMotion ? "auto" : "smooth",
          block: "start",
        });
      });
    });

    root.querySelectorAll("[data-cf-sc-buy-jump]").forEach((link) => {
      link.addEventListener("click", (event) => {
        const target = document.querySelector(link.getAttribute("href"));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({
          behavior: reducedMotion ? "auto" : "smooth",
          block: "center",
        });
      });
    });

    variantInputs.forEach((input) => {
      input.addEventListener("change", () => {
        if (!input.checked) return;
        updateVariantExperience(root, input, true);
      });
    });

    let floatFrame = 0;
    const updateFloatBuy = () => {
      window.cancelAnimationFrame(floatFrame);
      floatFrame = window.requestAnimationFrame(() => {
        if (!root.isConnected || !hero || !floatBuy) return;
        const storyPower = document.querySelector("[data-cf-sc-power]");
        const storyFit = document.querySelector("#cf-sc-fit");
        const imageChapters = document.querySelectorAll("#cf-sc-contexts, #cf-sc-details, #cf-sc-environments");
        const storyClose = document.querySelector("[data-cf-sc-end], .cf-sc-close");
        const rect = hero.getBoundingClientRect();
        const powerRect = storyPower?.getBoundingClientRect();
        const fitRect = storyFit?.getBoundingClientRect();
        const imageChapterVisible = Array.from(imageChapters).some((chapter) => {
          const bounds = chapter.getBoundingClientRect();
          return bounds.bottom > 0 && bounds.top < window.innerHeight;
        });
        const closeRect = storyClose?.getBoundingClientRect();
        floatBuy.classList.toggle(
          "is-visible",
          rect.bottom < window.innerHeight * 0.34 &&
            (!powerRect || powerRect.bottom < window.innerHeight *
              (storyPower.hasAttribute("data-cf-sc-proof") ? 0.2 : 0.94)) &&
            (!fitRect ||
              fitRect.bottom <= 0 ||
              fitRect.top >= window.innerHeight) &&
            !imageChapterVisible &&
            (!closeRect || closeRect.top > window.innerHeight * 0.9),
        );
      });
    };

    updateFloatBuy();
    window.addEventListener("scroll", updateFloatBuy, { passive: true });
    window.addEventListener("resize", updateFloatBuy);

    const selectedInput =
      variantInputs.find((input) => input.checked) || variantInputs[0];
    updateVariantExperience(root, selectedInput);

    if (form) {
      form.addEventListener("submit", () => {
        const selected = variantInputs.find((input) => input.checked);
        if (selected) updateVariantExperience(root, selected);
      });
    }
  };

  const initStory = (story) => {
    if (story.dataset.cfScReady === "true") return;
    story.dataset.cfScReady = "true";

    const root = document.querySelector("[data-cf-sc-root]");
    if (root) {
      updateVariantExperience(root, root.querySelector("[data-cf-sc-variant]:checked"));
    }

    story.querySelectorAll("[data-cf-sc-size-option]").forEach((button) => {
      button.addEventListener("click", (event) => {
        const currentRoot = document.querySelector("[data-cf-sc-root]");
        const variantInputs = currentRoot
          ? Array.from(currentRoot.querySelectorAll("[data-cf-sc-variant]"))
          : [];
        const input = variantInputs.find(
          (candidate) => candidate.value === button.dataset.variantId,
        );
        if (!input || input.disabled) return;
        event.preventDefault();
        input.checked = true;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
    });

    story.querySelectorAll('a[href^="#"]').forEach((link) => {
      link.addEventListener("click", (event) => {
        const target = document.querySelector(link.getAttribute("href"));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({
          behavior: reducedMotion ? "auto" : "smooth",
          block: "center",
        });
      });
    });

    const statement = story.querySelector(".cf-sc-statement");
    const statementLockup = story.querySelector(
      ".cf-sc-statement__lockup",
    );
    const builtSection = story.querySelector("#cf-sc-built");
    const builtMedia = builtSection?.querySelector(".cf-sc-built__media");
    const revealElements = Array.from(
      story.querySelectorAll("[data-cf-sc-reveal]"),
    );
    if (reducedMotion || typeof IntersectionObserver !== "function") {
      revealElements.forEach((element) => element.classList.add("is-visible"));
    } else {
      const standardRevealElements = revealElements.filter(
        (element) => element !== builtMedia,
      );
      const revealObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add("is-visible");
            revealObserver.unobserve(entry.target);
          });
        },
        { threshold: 0.16 },
      );
      standardRevealElements.forEach((element) =>
        revealObserver.observe(element),
      );

      if (builtSection && builtMedia) {
        const initialScrollY = window.scrollY;
        let builtSectionReady = false;
        let builtScrollSeen = false;
        let builtRevealObserver;

        const revealBuiltMedia = () => {
          if (!builtSectionReady || !builtScrollSeen) return;
          builtMedia.classList.add("is-visible");
          builtRevealObserver?.disconnect();
          window.removeEventListener("scroll", onBuiltScroll);
        };

        const onBuiltScroll = () => {
          if (Math.abs(window.scrollY - initialScrollY) < 2) return;
          builtScrollSeen = true;
          revealBuiltMedia();
        };

        builtRevealObserver = new IntersectionObserver(
          (entries) => {
            const sectionEntry = entries.find(
              (entry) => entry.target === builtSection,
            );
            builtSectionReady = Boolean(sectionEntry?.isIntersecting);
            revealBuiltMedia();
          },
          {
            rootMargin: "0px 0px -42% 0px",
            threshold: 0,
          },
        );

        window.addEventListener("scroll", onBuiltScroll, { passive: true });
        builtRevealObserver.observe(builtSection);
      }
    }

    const power = story.querySelector("[data-cf-sc-power]");
    if (!power) return;

    const journey = story.querySelector("[data-cf-sc-rhino-journey]");
    if (!journey) return;
    const journeyScene = journey?.querySelector("[data-cf-sc-rhino-scene]");
    const journeyFrames = journey
      ? Array.from(journey.querySelectorAll("[data-cf-sc-rhino-frame]"))
      : [];
    const journeyBeatSpecs = [
      {
        element: power,
        point: 0.08,
        name: "power-entry",
        spread: 0.205,
        size: 0.22,
        phoneSize: 0.29,
        y: 0.62,
        opacity: 0.24,
        cordOpacity: 0.5,
        brightness: 0.94,
        contrast: 1.12,
        lean: 4.8,
        ground: 0.6,
      },
      {
        element: power,
        point: 0.38,
        name: "power-strength",
        spread: 0.255,
        size: 0.235,
        phoneSize: 0.32,
        y: 0.62,
        opacity: 1,
        cordOpacity: 1,
        brightness: 1.08,
        contrast: 1.12,
        lean: 3.7,
        ground: 0.76,
      },
      {
        element: power,
        point: 0.64,
        name: "power-heat",
        spread: 0.265,
        size: 0.235,
        phoneSize: 0.32,
        y: 0.62,
        opacity: 1,
        cordOpacity: 1,
        brightness: 1.12,
        contrast: 1.12,
        lean: 3.2,
        ground: 0.76,
      },
      {
        element: power,
        point: 0.88,
        name: "power-lifetime",
        spread: 0.16,
        size: 0.22,
        phoneSize: 0.29,
        y: 0.62,
        opacity: 1,
        cordOpacity: 0,
        brightness: 1.04,
        contrast: 1.12,
        lean: 1.2,
        ground: 0.76,
      },
      {
        element: story.querySelector(".cf-sc-statement"),
        point: 0.08,
        name: "statement-entry",
        spread: 0.375,
        size: 0.155,
        phoneSize: 0.31,
        y: 0.8,
        phoneY: 0.84,
        opacity: 1,
        cordOpacity: 1,
        brightness: 1.05,
        contrast: 1.1,
        lean: 0,
        ground: 0.58,
      },
      {
        element: story.querySelector(".cf-sc-statement"),
        point: 0.4,
        name: "statement-stride",
        spread: 0.375,
        size: 0.155,
        phoneSize: 0.31,
        y: 0.8,
        phoneY: 0.84,
        opacity: 1,
        cordOpacity: 1,
        brightness: 1.05,
        contrast: 1.1,
        lean: 0,
        ground: 0.58,
      },
      {
        element: story.querySelector(".cf-sc-statement"),
        point: 0.72,
        name: "statement-obsidian",
        spread: 0.375,
        size: 0.155,
        phoneSize: 0.31,
        y: 0.8,
        phoneY: 0.84,
        opacity: 1,
        cordOpacity: 1,
        brightness: 1.05,
        contrast: 1.1,
        lean: 0,
        ground: 0.58,
      },
      {
        element: story.querySelector("#cf-sc-built"),
        point: 0.52,
        name: "construction",
        spread: 0.39,
        size: 0.16,
        y: 0.84,
        opacity: 0.64,
        cordOpacity: 0.52,
        brightness: 0.96,
        contrast: 1.08,
        lean: 0.45,
        ground: 0.42,
      },
      {
        element: story.querySelector(".cf-sc-use"),
        point: 0.52,
        name: "work-and-trail",
        spread: 0.39,
        size: 0.17,
        y: 0.86,
        opacity: 0.72,
        cordOpacity: 0.58,
        brightness: 1,
        contrast: 1.06,
        lean: 0.55,
        ground: 0.46,
      },
      {
        element: story.querySelector("#cf-sc-fit"),
        point: 0.5,
        name: "length-obsidian",
        spread: 0.39,
        size: 0.15,
        y: 0.84,
        opacity: 0.8,
        cordOpacity: 0.68,
        brightness: 0.32,
        contrast: 1.52,
        lean: 0.3,
        ground: 0.32,
      },
      {
        element: story.querySelector("#cf-sc-warranty"),
        point: 0.56,
        name: "warranty-guard",
        spread: 0.36,
        size: 0.19,
        y: 0.84,
        opacity: 0.96,
        cordOpacity: 0.88,
        brightness: 1,
        contrast: 1.06,
        lean: 0,
        ground: 0.58,
      },
      {
        element: story.querySelector(".cf-sc-faq"),
        point: 0.5,
        name: "answers-obsidian",
        spread: 0.4,
        size: 0.13,
        y: 0.86,
        opacity: 0.64,
        cordOpacity: 0.48,
        brightness: 0.3,
        contrast: 1.54,
        lean: 0,
        ground: 0.28,
      },
      {
        element: story.querySelector(".cf-sc-close"),
        point: 0.48,
        name: "final-hold",
        spread: 0.28,
        size: 0.17,
        y: 0.86,
        opacity: 0.92,
        cordOpacity: 0.72,
        brightness: 1,
        contrast: 1.06,
        lean: 0,
        ground: 0.54,
      },
    ].filter((beat) => beat.element);

    let journeyBeats = [];
    let journeyStart = 0;
    let journeyEnd = 0;
    let journeyFrame = 0;
    let journeyNeedsMeasure = true;
    let journeyPulseStartedAt = -1;
    let journeyPulseDistance = 0;
    let currentJourneyFrame = -1;
    let syncPowerState = null;

    const measureJourney = () => {
      const scrollTop = window.scrollY;
      const phoneJourney = window.innerWidth < 750;
      const compactJourney = window.innerWidth < 900;
      journeyBeats = journeyBeatSpecs.map((beat) => {
        const rect = beat.element.getBoundingClientRect();
        let responsiveY =
          phoneJourney && Number.isFinite(beat.phoneY)
            ? beat.phoneY
            : beat.y;
        let phoneSize = beat.phoneSize ?? 0.34;

        if (compactJourney && beat.name === "answers-obsidian") {
          responsiveY = phoneJourney ? 0.225 : 0.23;
          phoneSize = 0.23;
        }

        return {
          ...beat,
          phoneSize,
          y: responsiveY,
          position: scrollTop + rect.top + rect.height * beat.point,
        };
      });

      if (journeyBeats.length) {
        journeyStart =
          journeyBeats[0].position - window.innerHeight * 0.38;
        journeyEnd =
          journeyBeats[journeyBeats.length - 1].position +
          window.innerHeight * 0.4;
      }
      journeyNeedsMeasure = false;
    };

    const getJourneyState = (probe) => {
      if (!journeyBeats.length) return null;
      if (probe <= journeyBeats[0].position) return journeyBeats[0];
      if (probe >= journeyBeats[journeyBeats.length - 1].position) {
        return journeyBeats[journeyBeats.length - 1];
      }

      for (let index = 0; index < journeyBeats.length - 1; index += 1) {
        const start = journeyBeats[index];
        const end = journeyBeats[index + 1];
        if (probe > end.position) continue;
        const distance = Math.max(1, end.position - start.position);
        const progress = smoothstep(
          clamp((probe - start.position) / distance),
        );
        return {
          name: progress < 0.5 ? start.name : end.name,
          spread: lerp(start.spread, end.spread, progress),
          size: lerp(start.size, end.size, progress),
          phoneSize: lerp(start.phoneSize, end.phoneSize, progress),
          y: lerp(start.y, end.y, progress),
          opacity: lerp(start.opacity, end.opacity, progress),
          cordOpacity: lerp(
            start.cordOpacity,
            end.cordOpacity,
            progress,
          ),
          brightness: lerp(
            start.brightness,
            end.brightness,
            progress,
          ),
          contrast: lerp(start.contrast, end.contrast, progress),
          lean: lerp(start.lean, end.lean, progress),
          ground: lerp(start.ground, end.ground, progress),
        };
      }
      return journeyBeats[journeyBeats.length - 1];
    };

    const getPowerJourneyState = (progress) => {
      const strengthEnd = 0.38;
      const heatEnd = 0.7;

      if (progress < strengthEnd) {
        const phase = smoothstep(clamp(progress / strengthEnd));
        return {
          name: "power-strength",
          spread: lerp(0.205, 0.255, phase),
          size: lerp(0.22, 0.235, phase),
          phoneSize: lerp(0.29, 0.32, phase),
          y: 0.62,
          opacity: lerp(0.24, 1, phase),
          cordOpacity: lerp(0.5, 1, phase),
          brightness: lerp(0.94, 1.08, phase),
          contrast: 1.12,
          lean: lerp(4.8, 3.7, phase),
          ground: lerp(0.6, 0.76, phase),
        };
      }

      if (progress < heatEnd) {
        const phase = smoothstep(
          clamp((progress - strengthEnd) / (heatEnd - strengthEnd)),
        );
        return {
          name: "power-heat",
          spread: lerp(0.255, 0.265, phase),
          size: 0.235,
          phoneSize: 0.32,
          y: 0.62,
          opacity: 1,
          cordOpacity: 1,
          brightness: lerp(1.08, 1.12, phase),
          contrast: 1.12,
          lean: lerp(3.7, 3.2, phase),
          ground: 0.76,
        };
      }

      const phase = clamp((progress - heatEnd) / (1 - heatEnd));
      const cordFade = smoothstep(clamp(phase / 0.5));
      return {
        name: "power-lifetime",
        spread: lerp(0.265, 0.16, phase),
        size: lerp(0.235, 0.22, phase),
        phoneSize: lerp(0.32, 0.29, phase),
        y: 0.62,
        opacity: 1,
        cordOpacity: 1 - cordFade,
        brightness: lerp(1.12, 1.04, phase),
        contrast: 1.12,
        lean: lerp(3.2, 1.2, phase),
        ground: 0.76,
      };
    };

    const setJourneyFrame = (frameIndex) => {
      if (frameIndex === currentJourneyFrame) return;
      currentJourneyFrame = frameIndex;
      journeyFrames.forEach((frame) => {
        frame.classList.toggle(
          "is-current",
          Number(frame.dataset.cfScRhinoFrame) === frameIndex,
        );
      });
      if (journey) journey.dataset.cfScJourneyFrame = String(frameIndex);
    };

    const updateJourney = (timestamp = performance.now()) => {
      journeyFrame = 0;
      if (
        !journey ||
        !journeyScene ||
        !document.documentElement.contains(journey)
      ) {
        return;
      }
      if (journeyNeedsMeasure) measureJourney();

      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;
      if (statement && statementLockup) {
        const statementRect = statement.getBoundingClientRect();
        const rawStatementReveal = clamp(
          (viewportHeight * 0.54 - statementRect.top) /
            Math.max(1, viewportHeight * 0.26),
        );
        const statementReveal = reducedMotion
          ? rawStatementReveal >= 0.5
            ? 1
            : 0
          : smoothstep(rawStatementReveal);
        statementLockup.style.setProperty(
          "--cf-sc-statement-copy-opacity",
          statementReveal.toFixed(3),
        );
        statementLockup.style.setProperty(
          "--cf-sc-statement-copy-shift",
          `${lerp(24, 0, statementReveal).toFixed(2)}px`,
        );
      }
      const probe = window.scrollY + viewportHeight * 0.62;
      const powerRect = power.getBoundingClientRect();
      const powerTravel = Math.max(1, powerRect.height - viewportHeight);
      const powerProgress = clamp(-powerRect.top / powerTravel);
      const inPower =
        powerRect.bottom >= viewportHeight * 0.98 &&
        powerRect.top < viewportHeight;
      const fireIn = smoothstep(
        clamp((powerProgress - 0.34) / 0.1),
      );
      const fireOut =
        1 -
        smoothstep(clamp((powerProgress - 0.66) / 0.11));
      const fireBlend = inPower ? fireIn * fireOut : 0;
      const lifetimeBlend = inPower
        ? smoothstep(clamp((powerProgress - 0.72) / 0.16))
        : 0;
      journeyScene.style.setProperty(
        "--cf-sc-fire-opacity",
        fireBlend.toFixed(3),
      );
      journeyScene.style.setProperty(
        "--cf-sc-lifetime-opacity",
        lifetimeBlend.toFixed(3),
      );
      journeyScene.style.setProperty(
        "--cf-sc-lifetime-scale",
        lerp(0.96, 1, lifetimeBlend).toFixed(3),
      );
      if (syncPowerState) {
        syncPowerState(powerProgress, inPower);
      }
      // Let the infinity proof settle before the pair starts walking into the
      // statement section. The remaining scroll distance is still long enough
      // for a continuous, fully visible handoff.
      const handoffStartProgress = 0.86;
      const handoffStartBottom =
        powerRect.height - powerTravel * handoffStartProgress;
      const handoffEndBottom = viewportHeight * 0.28;
      const powerHandoff =
        powerRect.top < 0 &&
        powerRect.bottom <= handoffStartBottom &&
        powerRect.bottom > handoffEndBottom;
      let state = inPower
        ? getPowerJourneyState(powerProgress)
        : getJourneyState(probe);
      if (powerHandoff) {
        const start = getPowerJourneyState(handoffStartProgress);
        const end =
          journeyBeats.find((beat) => beat.name === "statement-entry") ||
          start;
        const handoffStartY =
          viewportWidth < 750 ? 0.49 : viewportWidth < 990 ? 0.5 : start.y;
        const handoffEndSize =
          viewportWidth >= 750 && viewportWidth < 990
            ? Math.min(250, Math.max(190, viewportWidth * 0.3)) /
              viewportWidth
            : end.size;
        const handoffProgress = clamp(
          (handoffStartBottom - powerRect.bottom) /
            Math.max(1, handoffStartBottom - handoffEndBottom),
        );
        state = {
          name: "statement-handoff",
          spread: lerp(start.spread, end.spread, handoffProgress),
          size: lerp(start.size, handoffEndSize, handoffProgress),
          phoneSize: lerp(
            start.phoneSize,
            end.phoneSize,
            handoffProgress,
          ),
          y: lerp(handoffStartY, end.y, handoffProgress),
          opacity: lerp(start.opacity, end.opacity, handoffProgress),
          cordOpacity: lerp(
            start.cordOpacity,
            end.cordOpacity,
            handoffProgress,
          ),
          brightness: lerp(
            start.brightness,
            end.brightness,
            handoffProgress,
          ),
          contrast: lerp(
            start.contrast,
            end.contrast,
            handoffProgress,
          ),
          lean: lerp(start.lean, end.lean, handoffProgress),
          ground: lerp(start.ground, end.ground, handoffProgress),
        };
      }
      const active =
        Boolean(state) &&
        (inPower || (probe >= journeyStart && probe <= journeyEnd));

      journeyScene.classList.toggle("is-active", active);
      if (!active || !state) {
        journey.dataset.cfScJourneyActive = "false";
        journeyScene.style.setProperty("--cf-sc-journey-opacity", "0");
        return;
      }

      journey.dataset.cfScJourneyStage = state.name;
      journey.dataset.cfScJourneyActive = "true";

      const mobile = viewportWidth < 750;
      const statementPresentation = state.name.startsWith("statement-");
      const statementHold =
        statementPresentation && state.name !== "statement-handoff";
      let size = Math.min(
        viewportWidth * state.size,
        viewportHeight * 0.42,
        440,
      );
      let spread = viewportWidth * state.spread;
      let y = viewportHeight * state.y;

      if (mobile) {
        size = Math.min(
          154,
          Math.max(88, viewportWidth * (state.phoneSize || 0.34)),
        );
        const availableSpread = Math.max(
          0,
          (viewportWidth - size) / 2 - 12,
        );
        spread = Math.max(
          0,
          Math.min(
            viewportWidth * state.spread,
            availableSpread,
          ),
        );
        y = inPower && !statementPresentation
          ? Math.min(viewportHeight * 0.49, 520)
          : viewportHeight *
            Math.min(state.y, statementPresentation ? 0.86 : 0.78);
      } else {
        size = Math.max(150, size);
        if (statementHold && viewportWidth < 990) {
          size = Math.min(250, Math.max(190, viewportWidth * 0.3));
        }
        const availableSpread = Math.max(
          0,
          (viewportWidth - size) / 2 - 36,
        );
        spread = Math.max(0, Math.min(spread, availableSpread));
        if (inPower && !statementPresentation && viewportWidth < 990) {
          y = Math.min(viewportHeight * 0.5, 540);
        }
      }

      let pulse = 0;
      if (!reducedMotion && journeyPulseStartedAt >= 0) {
        const pulseProgress = clamp(
          (timestamp - journeyPulseStartedAt) / 520,
        );
        pulse = Math.sin(pulseProgress * Math.PI) * journeyPulseDistance;
        if (pulseProgress < 1) {
          journeyFrame = window.requestAnimationFrame(updateJourney);
        } else {
          journeyPulseStartedAt = -1;
        }
      }
      spread += pulse;

      const inFinalHold =
        (inPower &&
          state.name === "power-lifetime" &&
          powerProgress > 0.86) ||
        state.name === "warranty-guard" ||
        state.name === "answers-obsidian" ||
        state.name === "final-hold" ||
        statementHold;
      const gaitDistance = Math.max(1, viewportHeight * 0.19);
      const gaitIndex = Math.abs(
        Math.floor((probe - journeyStart) / gaitDistance),
      ) % 4;
      const frameIndex = inFinalHold ? 3 : gaitIndex;
      const bobPattern = [0, -5, -3, 1];
      const bob = reducedMotion || statementHold
        ? 0
        : bobPattern[frameIndex] * Math.min(1.3, size / 420);
      const cordY = y - size * 0.052;
      const copyBottom = y - size * 0.45 - Math.max(18, viewportHeight * 0.012);
      const cordSpan = Math.min(
        viewportWidth * 0.96,
        spread * 2 + size * 0.24,
      );
      const cordThickness = statementPresentation
        ? mobile
          ? 10
          : Math.min(22, Math.max(14, viewportWidth * 0.011))
        : mobile
          ? 8
          : Math.min(18, Math.max(12, viewportWidth * 0.009));
      const materialProgress = clamp((1 - state.brightness) / 0.68);
      const cordBrightness = statementPresentation
        ? 1.38
        : lerp(1.32, 0.4, materialProgress);
      const cordContrast = statementPresentation
        ? 1.22
        : lerp(1.16, 1.58, materialProgress);

      journeyScene.style.setProperty(
        "--cf-sc-journey-spread",
        `${spread.toFixed(2)}px`,
      );
      journeyScene.style.setProperty(
        "--cf-sc-journey-rhino-size",
        `${size.toFixed(2)}px`,
      );
      journeyScene.style.setProperty(
        "--cf-sc-journey-rhino-y",
        `${y.toFixed(2)}px`,
      );
      journeyScene.style.setProperty(
        "--cf-sc-journey-cord-y",
        `${cordY.toFixed(2)}px`,
      );
      power.style.setProperty(
        "--cf-sc-power-copy-bottom",
        `${copyBottom.toFixed(2)}px`,
      );
      journeyScene.style.setProperty(
        "--cf-sc-journey-cord-span",
        `${cordSpan.toFixed(2)}px`,
      );
      journeyScene.style.setProperty(
        "--cf-sc-journey-cord-thickness",
        `${cordThickness.toFixed(2)}px`,
      );
      journeyScene.style.setProperty(
        "--cf-sc-journey-cord-brightness",
        cordBrightness.toFixed(3),
      );
      journeyScene.style.setProperty(
        "--cf-sc-journey-cord-contrast",
        cordContrast.toFixed(3),
      );
      journeyScene.style.setProperty(
        "--cf-sc-journey-opacity",
        (mobile ? state.opacity * 0.92 : state.opacity).toFixed(3),
      );
      journeyScene.style.setProperty(
        "--cf-sc-journey-cord-opacity",
        state.cordOpacity.toFixed(3),
      );
      journeyScene.style.setProperty(
        "--cf-sc-journey-brightness",
        state.brightness.toFixed(3),
      );
      journeyScene.style.setProperty(
        "--cf-sc-journey-contrast",
        state.contrast.toFixed(3),
      );
      journeyScene.style.setProperty(
        "--cf-sc-journey-lean",
        `${state.lean.toFixed(2)}deg`,
      );
      journeyScene.style.setProperty(
        "--cf-sc-journey-ground-opacity",
        state.ground.toFixed(3),
      );
      journeyScene.style.setProperty(
        "--cf-sc-journey-bob",
        `${bob.toFixed(2)}px`,
      );

      setJourneyFrame(frameIndex);
    };

    const requestJourneyUpdate = () => {
      if (!journeyFrame) {
        journeyFrame = window.requestAnimationFrame(updateJourney);
      }
    };

    story.querySelectorAll("[data-cf-sc-size-option]").forEach((button) => {
      button.addEventListener("click", () => {
        if (reducedMotion) return;
        journeyPulseDistance = button.dataset.title?.includes("72") ? 22 : 13;
        journeyPulseStartedAt = performance.now();
        requestJourneyUpdate();
      });
    });

    journeyFrames.forEach((frame) => {
      if (typeof frame.decode !== "function") return;
      frame.decode().catch(() => {
        if (journey) journey.dataset.cfScJourneyImageError = "true";
      });
    });

    if (typeof ResizeObserver === "function") {
      const journeyResizeObserver = new ResizeObserver(() => {
        journeyNeedsMeasure = true;
        requestJourneyUpdate();
      });
      journeyResizeObserver.observe(story);
      story.cfScJourneyResizeObserver = journeyResizeObserver;
    }

    story.dataset.cfScJourneyReady = "true";
    measureJourney();
    updateJourney();
    window.addEventListener("scroll", requestJourneyUpdate, {
      passive: true,
    });
    window.addEventListener("resize", () => {
      journeyNeedsMeasure = true;
      requestJourneyUpdate();
    });

    const title = power.querySelector("[data-cf-sc-power-title]");
    let lastTitle = "";

    const setPowerState = (progress) => {
      power.style.setProperty("--cf-sc-force-progress", progress.toFixed(4));

      const factIndex = progress < 0.38 ? 0 : progress < 0.74 ? 1 : 2;
      const stage = ["strength", "heat", "lifetime"][factIndex];
      const nextTitle = [
        "2,000 LB. STILL PULLING.",
        "700°F. HEAT RESISTANT.",
        "INDESTRUCTIBLE. LIFETIME WARRANTY.",
      ][factIndex];

      power.dataset.cfScPowerStage = stage;
      story.dataset.cfScPowerStage = stage;

      if (title && nextTitle !== lastTitle) {
        title.textContent = nextTitle;
        if (typeof title.animate === "function" && lastTitle) {
          title.animate(
            reducedMotion
              ? [{ opacity: 0.35 }, { opacity: 1 }]
              : [
                  { opacity: 0.2, transform: "translateY(0.12em)" },
                  { opacity: 1, transform: "translateY(0)" },
                ],
            {
              duration: reducedMotion ? 220 : 420,
              easing: "cubic-bezier(0.22, 1, 0.36, 1)",
            },
          );
        }
        lastTitle = nextTitle;
      }
    };

    syncPowerState = (progress, active) => {
      story.dataset.cfScPowerActive = active ? "true" : "false";
      setPowerState(progress);
    };

    requestJourneyUpdate();
  };

  const init = () => {
    document.querySelectorAll("[data-cf-sc-root]").forEach(initRoot);
    document.querySelectorAll("[data-cf-sc-story-root]").forEach(initStory);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);
})();
